import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// /norwood/ was a chart page with a quote form. It competed with
// /what-is-the-norwood-scale/ for the same searches (Search Console 15 Apr to
// 14 Oct 2026: 18 clicks vs 58). The chart moved to that post on 17 Oct 2026
// (src/content/wp-parity/posts/what-is-the-norwood-scale.md), and this URL
// sends visitors there in one 301 with the query string kept.
export const Route = createFileRoute("/norwood")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/what-is-the-norwood-scale/", location.searchStr), statusCode: 301 });
  },
});
